module.exports = __webpack_public_path__ + "static/media/Guide_1277_category.0736dae0.png";